import React, { useState } from "react";
import { Dropdown, TextArea } from "colbi_web_ui/lib/components/inputs";
import { SovosIcon } from "mosaic-react";
import { HighlightOff } from "mosaic-react-icons";
import styles from "./ConfigMergeContainer.module.sass";

const isNonCsvFileType = (fileType) =>
    Boolean(fileType && !String(fileType).toLowerCase().includes("csv"));

const entityMatchesFileType = (entityId, fileType) => {
    if (!fileType || !entityId) {
        return false;
    }
    const localePrefix = entityId.split("/")[0].replaceAll("_", "").toLowerCase();
    return String(fileType).toLowerCase().includes(localePrefix);
};

const ConfigContainer = ({ config, index, onChange, appliesToFilter, fileTypeToEntity }) => {
    const isMappingMode = Array.isArray(fileTypeToEntity) && fileTypeToEntity.length > 0;
    const initialFileType = config?.FileType || "";
    const [fileTypeSelected, setFileTypeSelected] = useState(initialFileType);
    const [isVisible, setIsVisible] = useState(
        isMappingMode && (Boolean(config?.Entity) || isNonCsvFileType(initialFileType)),
    );

    const handleDescriptionChange = (e) => {
        const updatedConfig = { ...config, Description: e.target.value };
        onChange(index, updatedConfig);
    };

    const handleConfigurationChange = (e) => {
        const updatedConfig = { ...config, Configuration: e.target.value };
        onChange(index, updatedConfig);
    };

    const handleFileTypeChange = (e) => {
        const selectedFileType = e.target.value.id;
        setFileTypeSelected(selectedFileType);
        const showEntity = isMappingMode && isNonCsvFileType(selectedFileType);
        setIsVisible(showEntity);
        const updatedConfig = { ...config, FileType: selectedFileType };
        if (isMappingMode) {
            updatedConfig.Entity = "";
        } else if (Object.prototype.hasOwnProperty.call(updatedConfig, "Entity")) {
            delete updatedConfig.Entity;
        }
        onChange(index, updatedConfig);
    };

    const handleEntityChange = (entity) => {
        const updatedConfig = { ...config, Entity: entity };
        onChange(index, updatedConfig);
    };

    const handleRemoveClick = () => {
        onChange(index, null);
    };

    const entityOptions = (fileTypeToEntity || []).filter(({ id }) =>
        entityMatchesFileType(id, fileTypeSelected),
    );

    return (
        <div className={`${styles["rule-entry"]} ${styles["flex"]}`}>
            <div className={styles["input-field"]}>
                <div className={styles["locale-container"]}>
                    <Dropdown
                        placeholder={""}
                        className={styles["period-dropdown"]}
                        secondary
                        options={appliesToFilter}
                        value={config ? config.FileType : ""}
                        onChange={(e) => {
                            handleFileTypeChange(e);
                        }}
                    />
                    {isMappingMode ? (
                        <Dropdown
                            className={styles[`entity-dropdown-${isVisible ? "visible" : "hidden"}`]}
                            placeholder={""}
                            secondary
                            options={entityOptions}
                            value={config ? config.Entity : ""}
                            onChange={(e) => {
                                const entity = (fileTypeToEntity || []).find(
                                    (entry) => entry.id === e.target.value.id,
                                );
                                if (!entity) {
                                    return;
                                }
                                handleEntityChange(entity.id);
                            }}
                        />
                    ) : null}
                    <div className={styles["remove-button-container"]}>
                        <button
                            type="button"
                            className={styles["remove-button"]}
                            onClick={handleRemoveClick}
                        >
                            <SovosIcon>
                                <HighlightOff />
                            </SovosIcon>
                        </button>
                    </div>
                </div>
                <div>
                    <TextArea
                        className={styles["login-text-input"]}
                        type="text"
                        autoComplete="off"
                        autoCorrect="off"
                        spellCheck="false"
                        name={`Title`}
                        placeholder={`Enter a Description`}
                        value={config ? config.Description : ""}
                        onChange={handleDescriptionChange}
                    />
                    <TextArea
                        className={styles["login-text-input"]}
                        type="text"
                        autoComplete="off"
                        autoCorrect="off"
                        spellCheck="false"
                        name={`Configuration`}
                        placeholder={`Enter a Configuration`}
                        value={config ? config.Configuration : ""}
                        onChange={handleConfigurationChange}
                    />
                </div>
            </div>
        </div>
    );
};

export default ConfigContainer;
